module.exports = __webpack_public_path__ + "static/media/WEB_59.b485cb20.png";